import { Component, OnInit, Input, Output, EventEmitter, AfterViewInit, ViewChildren } from '@angular/core';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { AppdataService } from 'src/app/services/services/appdata.service';
import { LoginserviceService } from 'src/app/services/services/loginservice.service';
import { ActivatedRoute, Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-addcategory',
  templateUrl: './addcategory.component.html',
  styleUrls: ['./addcategory.component.css']
})
export class AddcategoryComponent implements OnInit,AfterViewInit {

  @ViewChildren('input')firstipcontrol;

  formname:String="Category"; 

//Display
formmode:string="Add";

//Mode Values
isaddmode:boolean=false;
iseditmode:boolean=false;
isdeletemode:boolean=false;
isviewmode:boolean=false;

isloading: boolean = false;
isprivilage: boolean = false;
showProgress: boolean = false;

//Save Validation
submitted:boolean;
successfully:boolean;
saveloading: boolean;

//Edit Get Values
categoryColl:any=[];
categoryBO:any={};
categoryid:number=0

categoryform=new FormGroup({
  categoryid:new FormControl(0),          
  categoryname:new FormControl('',Validators.required),  
 inactive:new FormControl(false),  
});


@Input() ischild :boolean=false;
@Input() ischildadd :boolean=false;
@Input() ischildkey :number=0
@Output() childChanged = new EventEmitter<number>();


constructor(private appService: AppdataService,private loginService:LoginserviceService,private route: ActivatedRoute,
   public router: Router,private toastr: ToastrService, private productFindService: NgbModal) { 
     this.route.queryParams.subscribe(params => {
       if(params.id!==undefined){
         this.categoryid = params.id
       }          
     });

     this.fnServiceChanges();
}

 
fnServiceChanges() {
  this.loginService.serviceAuthChange.subscribe((value) => {
    if (this.loginService.fnCheckCompany()) {
      if (this.fnCheckUserPririvilage()) {
        this.isloading = true;
        this.fnOnInitForm();
      }
      else {
        this.fnUserFailedForm();
      }
    }
    else {
      this.fnUserFailedForm();
    }

  });
}



ngOnInit() {
  try {
    if (this.loginService.fnCheckCompany()) {
      if (this.fnCheckUserPririvilage()) {
        this.isloading = true;
        this.fnOnInitForm();
      }
      else {
        this.fnUserFailedForm();
      }
    }
    else {
      this.loginService.fnGetUserRoleList();
    }

  } catch (ex) {
    this.fnShowErrorMsg(ex);
  }
}

fnOnInitForm() {
   try{
       this.isaddmode=true;
       this.categoryform.reset();
       this.fnInitializeFormGroup(); 

       if(this.categoryid>0){
         this.fngetCategory();
       }
   }catch(ex){
     this.fnShowErrorMsg(ex);
   }
}
fnCheckUserPririvilage() {
  var _check: boolean = false;
  if (this.categoryid > 0) {
    _check = this.loginService.fnCheckUserRoleAction(this.formname, 'ALTER')
  } else {
    _check = this.loginService.fnCheckUserRoleAction(this.formname, 'CREATE')
  }

  return _check;
}

fnUserFailedForm() {
  this.isprivilage = true;
}
ngAfterViewInit()
{
  this.loginService.fnSetFirstControlFocus('txtfirst');
}
fnInitializeFormGroup(){
   this.categoryform.setValue({
    categoryid:0,    
    categoryname:'',
     inactive:false              
   })
}

//Get 
fngetCategory() {
  if (this.showProgress) {
    return;
  }         
     var data = {
       'categoryid':this.categoryid,
       'companyid':this.loginService.fnGetCompanyId()          
     }
     this.appService.getCategory(data)
     .subscribe(
       (res)=>{                
         if(res.json().status===200){
          this.fnHideProgress();
  
           this.categoryColl=res.json().result;
           var editdata = this.categoryColl[0]; 
           this.categoryBO=editdata;       
           this.fnEditMode(editdata);
         }
         else {
          this.fnHideProgress();

           this.loginService.fnAPIError(res.json())
         }
         
     },
     (err)=>{ 
      this.fnHideProgress();
         
       this.toastr.error('Error', err);
     })
}



//Save Btn Click
fnSaveBtnClick(){
   try{
    if (this.saveloading) {
      return;        
  }
     this.submitted=true;
     this.successfully=false;
     //Validate
     if(this.categoryform.valid){
         //Check
         this.saveloading = true;

         var data = {
               'categoryid': this.categoryid,                      
               'categoryname':this.categoryform.get('categoryname').value, 
               'inactive':this.categoryform.get('inactive').value,            
               'companyid':this.loginService.fnGetCompanyId(),
               'createdby': this.loginService.fnGetModUserId(),  
              'modifiedby':this.loginService.fnGetModUserId(),                                                              
         }

       
         this.appService.fnCheckCategory(data).subscribe(
           (res)=>{
             if(res.json().status===200){  
               var _checkresult=res.json().result[0].checkfield;
             
               if(_checkresult==="done"){
                     if (this.categoryform.get('categoryid').value>0){
                       //Update 
                       this.fnSetCategory(data);
                     }
                     else{
                       //Insert 
                       this.fnInsertCategory(data);
                     }
               }
               else{        
                     if(_checkresult==="name"){
                      this.saveloading = false;

                       this.categoryform.controls['categoryname'].setErrors({'notfound': true});
                     }
               }
             }
             else {
              this.saveloading = false;

               this.loginService.fnAPIError(res.json())
             }
         },
         (err)=>{
          this.saveloading = false;

             this.toastr.error('Error', err);           
         });
      }
   }catch(ex){
    this.saveloading = false;

     this.fnShowErrorMsg(ex);
   }
}

//Insert
fnInsertCategory(data){    
 
   this.appService.fnInsertCategory(data).subscribe(
     (res)=>{
      this.saveloading = false;

       if(res.json().status===200){  
         if(res.json().result!=""){
          this.ischildkey=res.json().result[0][0].categoryid;
          this.ischildadd=true;

           this.toastr.success('', "The new category has been added successfully.Insert Successfully");
           this.fnInsertActivityLog('INSERT', 0, data.categoryname);
           this.fnCloseForm();
         }
       }
       else {
         this.loginService.fnAPIError(res.json())
       }
   },
     (err)=>{
      this.saveloading = false;

       this.toastr.error('Error', err);
     });

}

//Set
fnSetCategory(data){    

this.appService.fnSetCategory(data).subscribe(
 (res)=>{
  this.saveloading = false;

   if(res.json().status===200){  
         if(res.json().result!=""){
             this.toastr.success('', "The category has been updated successfully.");
             this.fnInsertActivityLog('EDIT',this.categoryid,data.categoryname);
             this.fnCloseForm();        
         } 
     }
   else {
     this.loginService.fnAPIError(res.json())
   }
 },
 (err)=>{
  this.saveloading = false;

   this.toastr.error('Error', err);
 });

}

//Close
fnCloseForm(){
try{
  if(this.ischild===false){
    this.router.navigate(['/Category']);
  }
  else{
    var pBO:any={
      isadd:this.ischildadd,
      childkey:this.ischildkey,
      doctype:'CATEGORY'    
    }
    this.childChanged.emit(pBO);
  }


}catch(ex){
   this.fnShowErrorMsg(ex);
}
}

private fnEditMode(deptBO){
 this.categoryform.setValue({ 
  categoryid:deptBO.categoryid,     
  categoryname:deptBO.categoryname,
   inactive:deptBO.inactive
 });

 this.formmode="Edit";
   
 this.iseditmode=true;
 this.isdeletemode=false;
 this.isviewmode=false;
}
fnInsertActivityLog(action,refno,desc){
  try{
    var data={
      logtype:action,
      logat:this.formname,
      refnum:refno,
      logdescr:desc,companyid: this.loginService.fnGetCompanyId(),         
      logby:this.loginService.fnGetModUserId(),
    }
  

    this.appService.fnInsertActivity(data).subscribe(
      (res)=>{
      },
      (err)=>{
     
      });

  }catch{

  }
}
private fnShowProgress() {
  this.showProgress = true;
}
private fnHideProgress() {
  this.showProgress = false;
}
private  fnShowErrorMsg(ex){
this.toastr.warning('Internal Error', ex);       
}







}
